<template>
  <div class="contenedor-difusion">
    <!-- <Header2/> -->
    <section class="contenedor-c">
      <div class="contenedor-titulo">
        <h1>Nivel 1- Requisitos para ofrecer talleres, workshops u otras actividades</h1>
        <div class="barra"></div>
      </div>
      <section class="contenedor-login">
        <div class="contenedor-difusion-imagen">
          <img src="@/assets/abhi.png" alt="Abhi Iyengar">
        </div>
        <div class="contenedor-seminario">
          <p>Es importante resaltar que la profundización en el método, de acuerdo con la Constitución de Pune y el Manual de Certificación reformado 2020, queda a cargo de los profesores de Nivel II que estén certificados por al menos 3 años en dicho nivel (nuevo sistema) o aquellos certificados en el nivel junior intermedio 2, con un mínimo de dos años.</p>
          <p>Si bien el Manual de Certificación 2020 no contempla la posibilidad de que los profesores de Nivel I realicen talleres, workshops o retiros, en atención a las particularidades de nuestro país y con el espíritu de preservar las enseñanzas de B.K.S. Iyengar, así como de fomentar la formación continua en el método, se establece que aquellos profesores de Nivel I que deseen expandir la difusión del método mediante estas actividades podrán hacerlo a través de clases generales introductorias, siempre que cumplan con lo siguiente:</p>
          <h2 class="titulo_beneficios">Requisitos</h2>
          <p>Para los profesores de Nivel I que desean compartir y difundir el método Iyengar a través de workshops o talleres, es fundamental contar con el acompañamiento de un mentor o profesor de mayor experiencia. Este vínculo no solo brinda sostén y guía en cada paso, sino que también fortalece la formación continua dentro de la comunidad.</p>
          <p>Se considera workshop o taller toda sesión de enseñanza de la metodología y práctica del Yoga Iyengar que cumpla con las siguientes condiciones:</p>
          <ul class="lista_precios_seminario">
            <li>⚬ Supera los 90 minutos de duración.</li>
            <li>⚬ Se dicta fuera del cronograma habitual de clases.</li>
            <li>⚬ Está dirigido a personas más allá de los alumnos regulares de la sala.</li>
            <li>⚬ Aborda un tema específico del método, basado en los asanas y pranayamas del silabario correspondiente al nivel I.</li>
          </ul>
          <p>Ejemplos de posibles temas:</p>
          <ul class="lista_precios_seminario">
            <li>⚬ Uso de elementos en las posturas.</li>
            <li>⚬ Principios de alineación en posturas de pie, flexiones hacia adelante, extensiones o invertidas.</li>
            <li>⚬ Introducción al pranayama.</li>
          </ul>
          <h2 class="titulo_beneficios">Requisitos Previos</h2>
          <ul class="lista_precios_seminario">
            <li>1. Haber impartido clases generales de Nivel I por un mínimo de dos años desde la certificación.</li>

            <li>2. Participar anualmente en los encuentros organizados por la AAYI con profesores del RIMYI.</li>
            <li>3. Tomar clases regulares y contar con la guía de un mentor o profesor de mayor nivel, a quien se deberá:</li>
            <ul class="lista_precios_seminario">
              <li>⚬ Expresar el interés en difundir el método.</li>
              <li>⚬ Presentar un proyecto detallado con el contenido del taller, ajustado al programa de Nivel I.</li>
              <li>⚬ Obtener la conformidad del mentor para cada actividad a realizar, quien firmará una carta de recomendación: <a
             href="https://drive.google.com/file/d/1y0fPVBJnXaAykCQPzd3yg3lJ64CJbex2/view"
             target="_blank"
             class="link_beneficios"
             >
              Link carta de recomendación
            </a></li>
              <li>⚬ Completar el siguiente formulario por cada actividad que se desee organizar: <a
             href="https://docs.google.com/forms/d/e/1FAIpQLSfhx8Xb-VdcifKnG2ui94OrbCZwQwpIaSnnX1mBrz9gYrAWEA/viewform"
             target="_blank"
             class="link_beneficios"
             >
              Link formulario de registro
            </a></li>
            </ul>
          </ul>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
import store from '../store'
export default {
  name: 'Nivel1Requisitos',
  components: {
  },
  data: function () {
    return {
      store,
      checked: false
    }
  },
  methods: {
  },
  mounted: function () {
  }
}
</script>

<style>

</style>
